<script>
import {mapState} from "vuex";
import dayjs from "dayjs";
import _ from "lodash";

export default {
    name: "DiagonalStripeTexture",
    props: {
        locationId: String,
        dateStr: String
    },
    computed: {
        ...mapState({
            downtimeCalendar: state => state.calendarShift.downtimeCalendar,
        }),
        polygon() {
            let tl = [];
            if (this.dateStr && this.locationId) {
                let list = this.downtimeCalendar[`${this.locationId}`];
                if (list) {
                    let dayS = dayjs(this.dateStr).startOf('day');
                    let dayE = dayjs(this.dateStr).endOf('day');
                    for (let item of list) {
                        if (item.endTime.isAfter(dayS) && item.beginTime.isBefore(dayE)) {
                            tl.push({
                                start: item.beginTime.isBefore(dayS) ? dayS : item.beginTime,
                                end: item.endTime.isAfter(dayE) ? dayE : item.endTime
                            });
                        }
                    }
                }
            }
            if (tl.length > 0) {
                _.orderBy(tl, ['start'], ['asc']);
                let i = 1, pre = tl[0];
                while (i < tl.length) {
                    let item = tl[i];
                    if (item.start.isAfter(pre.end)) {
                        i++;
                        pre = item;
                    } else {
                        pre.end = item.end;
                        tl.splice(i, 1);
                    }
                }
                let path = [];
                let dayStartMill = dayjs(this.dateStr).startOf('day').valueOf();
                for (let item of tl) {
                    let offset = (item.start.valueOf() - dayStartMill) / 864000;
                    let end = offset + (item.end.valueOf() - item.start.valueOf()) / 864000;
                    path.push(`${offset}% 100%, ${offset}% 0, ${end}% 0, ${end}% 100%`)
                }
                return path.join(", ")
            }
            return null;
        },
    },
}
</script>

<template>
    <div v-if="polygon" class="texture" :style="`clip-path: polygon(${polygon});`"/>
</template>

<style scoped>

.texture {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
        135deg,
        #a9aeb8 0, #a9aeb8 25%, transparent 25%, transparent 50%,
        #a9aeb8 50%, #a9aeb8 75%, transparent 75%, transparent
    );
    background-size: 9px 9px;
    //clip-path: polygon(10% 100%, 10% 0, 25% 0, 25% 100%, 50% 100%, 50% 0, 75% 0, 75% 100%);
}
</style>
